module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_600.01808b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/fullscreen-image_hero_600.png
// module id = Wz5h
// module chunks = 0